import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { IRole } from '../roles.interface';
import { RolesService } from '../roles.service';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';

let self: any;

@Component({
  selector: 'app-roles-modal',
  templateUrl: './roles-modal.component.html',
  styleUrls: ['./roles-modal.component.css']
})
export class RolesModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  loading: boolean = false;
  saving: boolean = false;
  role!: IRole;
  form!: UntypedFormGroup;
  submitted = false;
  isDev!: boolean;

  constructor(
    public _RolesService: RolesService,
    private _dialogService: DialogService,
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private ref: ChangeDetectorRef,
    private _AuthService: AuthService
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.isDev = this._AuthService.isRole('dev');
    if (this.role._id) this.getRole();
    else this.buildForm();
  }

  getRole() {
    this.loading = true;
    this._RolesService.getRole(this.role._id || '').subscribe((role) => {
      this.role = role;
      this.buildForm();
      this.loading = false;
    });
  }

  get f() { return this.form.controls; }
  buildForm() {
    this.form = this.fb.group({
      name: [this.role.name, [Validators.required]],
      isDeleted: [this.role.isDeleted]
    });
  }

  setEditable() {
    this.readOnly = false;
  }

  onSubmit() {
    this.submitted = true;
    let data: IRole = _.cloneDeep(this.form.value);
    if (this.form.invalid) return;
    this.saving = true;
    if (this.role._id) {
      data._id = this.role._id;
      this._RolesService.updateRole(data).subscribe((role) => {
        this.dialog.close(role);
      });
    } else {
      this._RolesService.createRole(data).subscribe((role) => {
        this.dialog.close(role);
      });
    }
  }
}